export default "__VITE_ASSET__B210zi9j__"